var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14286 0.857117L3.85715 5.14283L8.14286 9.42854",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.1428C3 15.9229 3.52784 17.6629 4.51677 19.143C5.50571 20.623 6.91131 21.7766 8.55585 22.4577C10.2004 23.1389 12.01 23.3172 13.7558 22.9699C15.5016 22.6226 17.1053 21.7655 18.364 20.5068C19.6226 19.2481 20.4798 17.6445 20.8271 15.8986C21.1743 14.1528 20.9961 12.3432 20.3149 10.6987C19.6337 9.05414 18.4802 7.64853 17.0001 6.6596C15.5201 5.67066 13.78 5.14282 12 5.14282H3.85714",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayIcon);
export default __webpack_public_path__ + "static/media/replay-icon.291725a463613c697daa0ef1596dc6b2.svg";
export { ForwardRef as ReactComponent };